module.exports = __webpack_public_path__ + "assets/img/25-l.6d388ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/25-l.jpg
// module id = h+hI
// module chunks = 0